module.exports = __webpack_public_path__ + "static/media/わたあめ二郎.1e18bddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/わたあめ二郎.png
// module id = 335
// module chunks = 10